module.exports = __webpack_public_path__ + "img/04.c220a6fb.jpg";